import { State } from 'src/redux';

import { isLoading } from 'src/services/api';

export const getAuth = (state: State) => state.auth;

export const getIsAuthLoading = (state: State) => isLoading(getAuth(state));

export const getToken = (state: State) => state.auth.token;
